import React, { useState, useRef, useEffect } from 'react';

export default function DropdownMenu({ onRegenerate }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close the menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={dropdownRef} style={{ position: 'absolute', top: '1em', right: '1em' }}>
      <button
        onClick={() => setMenuOpen(prev => !prev)}
         style={{
          backgroundColor: 'transparent',
          border: '2px solid #a3de00',
          borderRadius: '4px',
          color: '#a3de00',
          fontSize: '1.5em',
          padding: '0.2em 0.4em',
          cursor: 'pointer',
          transition: 'background-color 0.2s, color 0.2s'
        }}
        aria-label="More options"
      >
        ⋯
      </button>

      {menuOpen && (
        <div style={{
          position: 'absolute',
          right: 0,
          marginTop: '0.5em',
          backgroundColor: '#2a2a2a',
          border: '1px solid #555',
          borderRadius: '4px',
          padding: '0.5em 0',
          zIndex: 100,
          minWidth: '160px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.3)'
        }}>
          <button
            onClick={() => {
              setMenuOpen(false);
              onRegenerate(); // trigger action passed from parent
            }}
            style={{
              background: 'none',
              border: 'none',
              color: 'white',
              padding: '0.5em 1em',
              width: '100%',
              textAlign: 'left',
              cursor: 'pointer',
            }}
          >
            Regenerate plots
          </button>
        </div>
      )}
    </div>
  );
}
